import { render, staticRenderFns } from "./FormEditHeader.vue?vue&type=template&id=fa56f0ae&scoped=true&"
import script from "./FormEditHeader.vue?vue&type=script&lang=js&"
export * from "./FormEditHeader.vue?vue&type=script&lang=js&"
import style0 from "./FormEditHeader.vue?vue&type=style&index=0&id=fa56f0ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa56f0ae",
  null
  
)

export default component.exports